import React from 'react';
import LoanCalculator from './components/LoanCalculator';

function App() {
  return (
    <div className="App">
      <LoanCalculator />
    </div>
  );
}

export default App; 